export enum Spinner {
    FullScreen = 'full',
    PartialScreen = 'partial'
}
